export default __webpack_public_path__ + "static/media/image_dos.aa3431cb.PNG";